import React, { useEffect, useState } from "react";
import { DialogActions, Typography } from "@material-ui/core";
import ContentLayout from "../../../../partials/content/ContentLayout";
import { getTickets } from "../../../../services/crm/ticketService";
import "./chat.scss";
import { Badge } from "react-bootstrap";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import DialogLayout from "../../../../partials/content/DialogLayout";
import TicketDetail from "./ticketDetail";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
const Ticket = ({ history }) => {
  const { reload } = useGlobalData();
  const [tickets, setTickets] = useState([]);
  const [openTicketDetail, setOpenTicketDetail] = useState(false);
  const [ticket, setTicket] = useState({ ID: 0 });
  useEffect(() => {
    getTicketsData();
  }, [reload]);

  const ticketDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      <PageSubHeader
        title="Ticket List"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/crm/ticket",
            title: "Tickets",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/menu");
            },
          },
        ]}
      />
      <ContentLayout>
        <div className="row">
          <div className="col-2">
            <Typography align="center">
              <button className="btn btn-icon btn-label-success btn-md btn-circle mx-1">
                1
              </button>
              <br />
              Open
            </Typography>
          </div>
          <div className="col-2">
            <Typography align="center">
              <button className="btn btn-icon btn-label-primary btn-md btn-circle mx-1">
                1
              </button>
              <br />
              Claimed
            </Typography>
          </div>
          <div className="col-2">
            <Typography align="center">
              <button className="btn btn-icon btn-label-warning btn-md btn-circle mx-1">
                1
              </button>
              <br />
              In Progress
            </Typography>
          </div>
          <div className="col-2">
            <Typography align="center">
              <button className="btn btn-icon btn-label-danger btn-md btn-circle mx-1">
                1
              </button>
              <br />
              On Hold
            </Typography>
          </div>
          <div className="col-2">
            <Typography align="center">
              <button className="btn btn-icon btn-label-danger btn-md btn-circle mx-1">
                1
              </button>
              <br />
              Closed
            </Typography>
          </div>
          <div className="col-2">
            <Typography align="center">
              <button className="btn btn-icon btn-label-danger btn-md btn-circle mx-1">
                1
              </button>
              <br />
              Overdue
            </Typography>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <CustomDataTable
              data={tickets}
              dataDetailColumns={ticketDetailColumn}
              onRefreshData={() => {
                getTicketsData();
              }}
              onSelectedData={(rowData) => {
                setTicket(rowData);
                setOpenTicketDetail(true);
              }}
              columns={[
                {
                  header: "Ticket ID",
                  field: "ID",
                  body: null,
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Subject",
                  field: "subject",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis text={rowData.subject} maxLine="1" />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Status",
                  field: "statusID",
                  body: (ticketItem) => (
                    <Badge
                      variant={
                        ticketItem.statusID === 1
                          ? "primary"
                          : ticketItem.statusID === 2
                          ? "secondary"
                          : ticketItem.statusID === 3
                          ? "success"
                          : ticketItem.statusID === 4
                          ? "warning"
                          : ticketItem.statusID === 5
                          ? "light"
                          : ticketItem.statusID === 6
                          ? "danger"
                          : null
                      }
                    >
                      {ticketItem.statusID === 1
                        ? "Open"
                        : ticketItem.statusID === 2
                        ? "Claimed"
                        : ticketItem.statusID === 3
                        ? "In Progress"
                        : ticketItem.statusID === 4
                        ? "On Hold"
                        : ticketItem.statusID === 5
                        ? "Closed"
                        : ticketItem.statusID === 6
                        ? "Overdue"
                        : null}
                    </Badge>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Customer Name",
                  field: "customerName",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.customerName}
                        maxLine="1"
                      />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Service Group",
                  field: "userGroup.groupName",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.userGroup.groupName}
                        maxLine="1"
                      />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Claimed By",
                  field: "userName",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis text={rowData.userName} maxLine="1" />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
              ]}
            />
          </div>
        </div>
      </ContentLayout>
      <DialogLayout
        open={openTicketDetail}
        title="Ticket Detail"
        maxWIdth="xl"
        onCloseDialog={handleCloseTicketDetail}
      >
        {ticket.ID > 0 ? (
          <TicketDetail
            ticketID={ticket.ID}
            onReloadTickets={() => {
              handleCloseTicketDetail();
              getTicketsData();
            }}
          />
        ) : null}

        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={handleCloseTicketDetail}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  function handleCloseTicketDetail() {
    setOpenTicketDetail(false);
  }

  async function getTicketsData() {
    const response = await getTickets();
    setTickets(response.data);
  }
};

export default Ticket;
